import Event from "events";
import ConfigStore from "./ConfigStore";

export enum EThemeModeType {
	LIGHT = "light",
	DARK = "dark",
}

class EventEmitter extends Event {}

export default class ThemeMode {
	private static ctx: ThemeMode;
	private _type: EThemeModeType = EThemeModeType.DARK;
	private readonly event = new EventEmitter();

	private constructor() {
		ThemeMode.ctx = this;
	}

	public static getInstance() {
		if (!ThemeMode.ctx) return new this();
		return ThemeMode.ctx;
	}

	public get type() {
		return this._type;
	}

	/**
	 * @returns removelistener callback
	 */
	public onSwitch(callback: (type: EThemeModeType) => void) {
		this.event.on("switch-theme-mode", callback);
		return () => {
			this.event.off("switch-theme-mode", callback);
		};
	}
	public toggle() {
		if (this.type === EThemeModeType.DARK) {
			this.switch(EThemeModeType.LIGHT);
			return this.type;
		}
		this.switch(EThemeModeType.DARK);
		return this.type;
	}

	public switch(type: EThemeModeType) {
		if (type === this.type && localStorage.getItem("theme-mode")) return;
		this._type = type;
		localStorage.setItem("theme-mode", this._type);
		this.event.emit("switch-theme-mode", this._type);
	}

	public init() {
		const defaultTheme = (ConfigStore.getInstance().config.defaultTheme as EThemeModeType) ?? EThemeModeType.DARK;
		const type = (localStorage.getItem("theme-mode") as EThemeModeType) ?? defaultTheme;
		this.switch(type);
	}
}
